const ROOT = 'dashboard/settings/users/';

export default {
	updateProfilePassword: `${ROOT}update-profile-password`
};
